<template>
  <v-layout column class="inner-pages">

    <Header :header-height="$auth.check() ? '70px': '120px'" />

    <v-flex px-5 pt-0 class="sfh-login-form background-image center-pb-10">
      <div class="pb-5">
        <input type="password" style="display:none" tabindex="-1"/>

        <v-text-field
          type="email"
          :autofocus=true
          v-validate="'required'"
          :error-messages="errors.collect('slot1.username')"
          v-model="username"
          label="Username or Email"
          data-vv-name="slot1.username"
          data-vv-scope="slot1"
        ></v-text-field>

        <v-text-field
          :append-icon="e1 ? 'visibility' : 'visibility_off'"
          @click:append="() => (e1 = !e1)"
          :type="e1 ? 'password' : 'text'"
          v-validate="'required'"
          :error-messages="errors.collect('slot1.password')"
          v-model="password"
          label="Password"
          id="passwordId"
          data-vv-name="slot1.password"
          ref="passwordRef"
          data-vv-scope="slot1"
          :onautocomplete=false
          @keyup.native.enter="login"
        ></v-text-field>

        <v-checkbox
          class="mt-0"
          color="primary"
          v-model="rememberMe"
          label="Remember me"
        ></v-checkbox>

        <v-btn
          block
          class="btn--block btn--flat btn--large mt-0"
          :loading="loading"
          color="primary"
          @click.prevent="login">
          Sign in
        </v-btn>

        <router-link
          class="caption mt-0 grey--text text--darken-2"
          tag="a"
          :to="{ name: 'ForgotPassword' }">
          Forgot password
        </router-link>

        <v-flex
          grey--text
          text--darken-2
          class="mt-2">
            I don't have an account
          <u>
            <strong>
              <a
                class="mt-3 grey--text text--darken-2"
                @click="gotoSignUp"
              >Sign Up</a></strong>
          </u>
        </v-flex>

      </div>
    </v-flex>
  </v-layout>
</template>

<script>
  import Vue from 'vue'
  import VeeValidate from 'vee-validate'
  import Header from '../../layouts/Header'
  import {mapMutations} from 'vuex'

  Vue.use(VeeValidate)
  export default {
    name: 'Login',
    components: {Header},
    data: () => ({
      loading: false,
      username: '',
      password: '',
      rememberMe: false,
      apiUrl: process.env.API_URL,
      siteUrl: process.env.SITE_URL,
      loginErrorMsg: '',
      e1: true,
      dictionary: {
        custom: {
          'slot1.username': {
            required: () => 'Username or Email is required'
          },
          'slot1.password': {
            required: () => 'Password is required'
          }
        }
      }
    }),
    created () {
      setTimeout(() => {
        if (this.$auth.token()) {
          this.$auth.watch.authenticated = true
          this.$router.push({name: 'Programs'})
        }
        this.$store.commit('setIsCompactHeader', true)
      }, 50)
      /* Resetting user */
      this.resetUser()
    },
    mounted () {
      this.$validator.localize('en', this.dictionary)
      const rememberMe = localStorage.getItem('login_remember_me')
      if (rememberMe === 'yes') {
        this.rememberMe = rememberMe
        this.username = localStorage.getItem('login_user_name')
        this.password = localStorage.getItem('login_password')
      }
    },
    methods: {
      ...mapMutations('registration', [
        'resetUser'
      ]),
      gotoSignUp () {
        this.$router.push({name: 'SignUp', params: {step: 'confirm-my-email'}})
      },
      jsonToQueryString (json) {
        return '' +
          Object.keys(json).map(function (key) {
            return encodeURIComponent(key) + '=' +
              encodeURIComponent(json[key])
          }).join('&')
      },
      me () {
        this.$http({
          url: `${this.apiUrl}/ws/playerservice/user/${this.username}?deck=${process.env.GAME_ID}`,
          method: 'GET',
          headers: {
            Authorization: 'Bearer ' + this.$auth.token()
          }
        }).then((res) => {
          this.$auth.user(res.data)
          this.$auth.watch.authenticated = true

          if (this.rememberMe) {
            localStorage.setItem('login_user_name', this.username)
            localStorage.setItem('login_password', this.password)
            localStorage.setItem('login_remember_me', 'yes')
          } else {
            localStorage.setItem('login_user_name', '')
            localStorage.setItem('login_password', '')
            localStorage.setItem('login_remember_me', 'no')
          }

          document.cookie = 'user_name=' + res.data.friendlyName + ';domain=cogneti.com'
          document.cookie = 'user_email=' + res.data.email + ';domain=cogneti.com'
          localStorage.setItem('user_name', res.data.friendlyName)
          const countryId = res.data.countryId !== null ? res.data.countryId : 233

          this.$store.commit('user/setCountry', countryId)
          this.$store.commit('user/setUserDetails', res.data)
          this.$store.commit('user/setAvatar', res.data.userImageUrl)
          this.$store.commit('user/setFirstName', res.data.firstName)
          this.$store.commit('user/setLastName', res.data.lastName)
          this.$store.commit('user/setUserId', res.data.id)
          this.$store.commit('user/setState', res.data.stateId)
          this.$store.commit('user/setPhone', res.data.phoneNumber)
          this.$store.commit('user/setAddressLine1', res.data.addressLine1)
          this.$store.commit('user/setAddressLine2', res.data.addressLine2)
          this.$store.commit('user/setCity', res.data.city)
          this.$store.commit('user/setPostalCode', res.data.postalCode)
          const keyEmail = localStorage.getItem('email')
          if (typeof keyEmail === 'undefined' || keyEmail !== res.data.email) {
            localStorage.setItem('email', res.data.email)
            this.$store.commit('setDashboardTourStart', 0)
            this.$store.commit('setNewUserLoggedin', true)
            this.$store.commit('setTourStatus', true)
            this.$store.commit('setLearnStatus', true)
            this.$store.commit('setQuizStatus', true)
            this.$store.commit('course/setLastPlayedLevel', 0)
            this.$store.commit('course/setLevels', [])
            this.$store.commit('course/setGroups', [])
            this.$store.commit('course/setMemberId', 0)
            this.$store.commit('course/setExamStatus', -1)
            this.$store.commit('course/setBadgeScore', -1)
            this.$store.commit('course/setCourseLevelLoadedAfterLogin', false)
          } else {
            this.$store.commit('setNewUserLoggedin', false)
          }
        })
      },
      login () {
        this.loginErrorMsg = ''
        this.$validator.validateAll('slot1').then((result) => {
          if (result) {
            this.loading = true
            let parameters = {
              grant_type: 'password',
              client_id: process.env.CLIENT_ID,
              client_secret: process.env.CLIENT_SECRET,
              username: this.username,
              password: this.password
            }
            // console.log(this.jsonToQueryString(parameters))
            this.loginLoader = true
            this.$auth.login({
              headers: {
              },
              data: this.jsonToQueryString(parameters),
              rememberMe: this.rememberMe,
              success (res) {
                // console.log('Auth Success')
                this.loginLoader = false
                this.$store.commit('setAuthToken', this.$auth.token())
                document.cookie = 'auth_token=' + this.$auth.token() + ';domain=cogneti.com'
                this.me()
              },
              error (err) {
                console.log('Error Occur:' + err)
                this.errors.add({
                  scope: 'slot1',
                  field: 'password',
                  msg: 'Invalid username or password'
                })
                this.loading = false
                this.loginLoader = false
              }
            })
          } else {
            this.loading = false
          }
        })
      }
    }
  }
</script>

<style scoped>
  .sfh-login-form {
    display: flex;
    flex-direction: inherit;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/auth/Login.vue